import { z } from 'zod';

export default function fallback<T extends z.Schema<unknown>>(
  schema: T,
  fallbackValue: z.infer<T>,
): z.ZodEffects<z.ZodAny, z.infer<T>, unknown> {
  return z.any().transform<z.infer<T>>((rawValue) => {
    const safe = schema.safeParse(rawValue);
    return safe.success ? safe.data : fallbackValue;
  });
}
